
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { faChevronLeft, faChevronRight, faCoffee, faToggleOff, faToggleOn } from '@fortawesome/free-solid-svg-icons';
import { Song, SongBar } from '../song/Song';
import { Transponder } from '../chord/Transponder';

@Component({
  selector: 'app-view-song',
  templateUrl: './Song.html',
  styleUrls: ['./style.css', './Song.css']
})
export class AppViewSong {
  public graph: boolean = true;
  public trans: { [index: string]: number } = { guitar: 0, ukulele: 0 };
  private _chordSize: number = 60;
  private _artist: string | null = null;
  private _title: string | null = null;
  private _instrument: string | null = null;
  private _songInfo: Song | null = null;
  public fa: { [index: string]: any } = {
    on: faToggleOn,
    off: faToggleOff,
    coffee: faCoffee,
    inc: faChevronRight,
    dec: faChevronLeft,
  };

  constructor(private readonly route: ActivatedRoute, private readonly http: HttpClient) {
    this.route.params.subscribe(params => {
      this._artist = params['artist'] ? params['artist'] : this._artist;
      this._title = params['title'] ? params['title'] : this._title;
    });
  }

  public get instrument(): string {
    if (this._instrument) {
      return this._instrument;
    }
    return this.song.instrument ? this.song.instrument : 'guitar';
  }

  public set instrument(v: string) {
    this._instrument = v;
  }

  public get chordSize(): number {
    return this._chordSize;
  }

  public set chordSize(inc: number) {
    this._chordSize = Math.max(30, Math.min(300, this._chordSize + inc));
  }

  public get song(): Song {
    if (!this._songInfo) {
      this._songInfo = { artist: 'Loading', title: 'Loading' } as Song;
      this.http.get<Song>('../assets/songs/' + this._artist + '/' + this._title + '.json')
        .subscribe((data: Song) => {
          console.info('Loaded song', this._artist, this._title, data);
          this._songInfo = data;
          switch (this._songInfo.instrument) {
            case 'ukulele':
              this.trans.guitar = -5;
              break;
            case 'guitar':
            default:
              this.trans.ukulele = 5;
              break;
          }
        }, (_error: any) => {
          console.info('Failed to load song', this._artist, this._title, _error);
          this._songInfo = { artist: 'ERROR:' + this._artist, title: 'ERROR:' + this._title } as Song;
        });
    }
    return this._songInfo;
  }

  public get chordList(): string[] {
    const chords: string[] = [];
    if (!this.song || !this.song.bars) {
      return chords;
    }
    const c: string[][] = this.song.bars.map((bars: SongBar[]) => bars
      .filter((bar: SongBar) => !!bar.chord)
      .map((bar: SongBar) => bar.chord)
    ) as string[][];
    c.forEach((ca: string[]) => {
      ca.forEach((c: string) => {
        if (chords.indexOf(c) < 0) {
          chords.push(c);
        }
      });
    });
    return chords;
  }

  public transpond(chord: string, steps: number = 0): string {
    return Transponder.transpond(chord, steps);
  }
}
